import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {

  return (

    <section className="privacy-page">

      <div className="privacy-container">

        <h1>Privacy Policy</h1>

        <p>
          Last updated: March 2026
        </p>

        <h2>Information We Collect</h2>

        <p>
          We may collect personal information such as your name, phone number,
          email address, and location when you fill out our contact or appointment forms.
        </p>

        <h2>How We Use Your Information</h2>

        <p>
          Your information is used only to contact you regarding appointments,
          provide clinic services, and improve our website experience.
        </p>

        <h2>Third-Party Services</h2>

        <p>
          Our website uses trusted third-party services including:
        </p>

        <ul>

          <li>EmailJS (to send appointment emails)</li>

          <li>GNews API (to display health news)</li>

          <li>Vercel (website hosting)</li>

          <li>OpenStreetMap / location services</li>

        </ul>

        <h2>Data Protection</h2>

        <p>
          We do not sell, rent, or share your personal information with third parties.
        </p>

        <h2>Contact Us</h2>

        <p>
          If you have questions about this Privacy Policy, contact:
        </p>

        <p>
          Dr Vikas Homoeopathy and Naturopathy Clinic<br/>
          Email: vikashomoeopathy@gmail.com<br/>
          Phone: +91 7396803203
        </p>

      </div>

    </section>

  );

}